import { Route, Switch } from "react-router-dom";
import Home from "../pages/Home";
import Login from "../pages/Login";
import SignUp from "../pages/SignUp";

function Routes({
  tec,
  setTec,
  isEdit,
  setIsEdit,
  isAdding,
  setIsAdding,
  user,
  setUser,
  isLogged,
  setIsLogged,
}) {
  return (
    <Switch>
      <Route exact path="/">
        <Login
          setUser={setUser}
          isLogged={isLogged}
          setIsLogged={setIsLogged}
        />
      </Route>
      <Route exact path="/signup">
        <SignUp />
      </Route>
      <Route exact path="/home">
        <Home
          tec={tec}
          setTec={setTec}
          isEdit={isEdit}
          setIsEdit={setIsEdit}
          isAdding={isAdding}
          setIsAdding={setIsAdding}
          user={user}
          setUser={setUser}
        />
      </Route>
    </Switch>
  );
}
export default Routes;
